(function ($) {
    $(document).ready(function () {
        $('.block-navigation__mobile').on('change', function () {
            var value = $(this).val();
            if (!value) return;
            var link = $(this).closest('.block-navigation__nav').find('a[href="' + value + '"]');
            if (link.length) link[0].click();
        });
    });
})(jQuery);
